import { useReactiveVar } from '@apollo/client';
import { useParams } from '@hulu/react-router-dom';
import { useCallback, useMemo } from 'react';

import useMetricsStatus from '../../../apis/graphql/metrics/useMetricsStatus';
import { selectedOrganizationIdVar, viewedDatesVar } from '../../../constants';
import { getDelayDatesMessageToShow, getDelayDatesString, getLastUpdatedDateToShow } from './utils';

type UseHandleMetricsStatusResponse = {
  delayDatesMessageToShow: string;
  lastUpdatedDateToShow: string;
  onCloseDelayDates: () => void;
};

const useHandleMetricsStatus = (adAccountIds: Array<string>): UseHandleMetricsStatusResponse => {
  const organizationId = useReactiveVar(selectedOrganizationIdVar) || '';
  const viewedDates = useReactiveVar(viewedDatesVar) || '';
  const { data: metricsStatus, error, loading } = useMetricsStatus(organizationId, adAccountIds);

  const delayDatesString = useMemo(() => getDelayDatesString(metricsStatus), [metricsStatus]);
  const lastUpdatedDateToShow = useMemo(() => getLastUpdatedDateToShow(metricsStatus, error), [error, metricsStatus]);
  const delayDatesMessageToShow = useMemo(
    () => getDelayDatesMessageToShow(delayDatesString, viewedDates, error),
    [error, viewedDates, delayDatesString]
  );

  const onCloseDelayDates = useCallback(() => {
    viewedDatesVar(delayDatesString);
  }, [delayDatesString]);

  if (loading) {
    return {
      delayDatesMessageToShow: '',
      lastUpdatedDateToShow: '',
      onCloseDelayDates,
    };
  }

  return {
    delayDatesMessageToShow,
    lastUpdatedDateToShow,
    onCloseDelayDates,
  };
};

export default useHandleMetricsStatus;
